function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStraightToEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M142.09,14.85C118.19-9.28,68.15-2.82,49.72,25.71c-29.22,45.24-9.22,125.87,99.13,126.72,120.41.95,97.08-94.96,62.96-117.4-24.33-16-46.58,3.18-69.72-20.19Z",
    style: {
      fill: "#1c2f35",
      opacity: 0.08,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 29.14,
    width: 194.16,
    height: 97.28,
    rx: 2.6,
    ry: 2.6,
    style: {
      fill: "#fff",
      stroke: "#6b6b6b",
      strokeMiterlimit: 10,
      strokeWidth: ".88px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 37.27,
    x2: 120,
    y2: 85.09,
    style: {
      fill: "none",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".88px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 105.7,
    x2: 120,
    y2: 113.34,
    style: {
      fill: "none",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".88px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 91.57,
    x2: 120,
    y2: 99.21,
    style: {
      fill: "none",
      stroke: "#a1a1a1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".88px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 40,
    width: 33.45,
    height: 33.45,
    rx: 3,
    ry: 3,
    style: {
      fill: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 82,
    width: 33.45,
    height: 33.45,
    rx: 3,
    ry: 3,
    style: {
      fill: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 40,
    width: 33.45,
    height: 33.45,
    rx: 3,
    ry: 3,
    style: {
      fill: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 82,
    width: 33.45,
    height: 33.45,
    rx: 3,
    ry: 3,
    style: {
      fill: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 51.5,
    width: 71.2,
    height: 49.58,
    rx: 3,
    ry: 3,
    style: {
      fill: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.11,41.83l10.04,10.04s0,0,0,0,0,0,0,0l10.65,10.65c.2.2.51.2.71,0s.2-.51,0-.71l-10.31-10.31,4.46-4.46c3.03-3.03,7.96-3.03,10.98,0l13.19,13.52V21.32c0-2.21-1.79-4-4-4h-64c-2.21,0-4,1.79-4,4v40.59l21.27-20.08c3.03-3.03,7.96-3.03,10.98,0Z",
    style: {
      fill: "#c4d8de",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.85,69.32h64c2.21,0,4-1.79,4-4v-4.73l-13.19-13.52c-3.02-3.02-7.95-3.02-10.98,0l-4.46,4.46,10.31,10.31c.2.2.2.51,0,.71s-.51.2-.71,0l-10.65-10.65s0,0,0,0,0,0,0,0l-10.04-10.04c-3.03-3.03-7.96-3.03-10.98,0l-21.27,20.08v3.41c0,2.21,1.79,4,4,4Z",
    style: {
      fill: "#c4d8de",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.85,69.32h64c2.21,0,4-1.79,4-4v-4.73l-13.19-13.52c-3.02-3.02-7.95-3.02-10.98,0l-4.46,4.46,10.31,10.31c.2.2.2.51,0,.71s-.51.2-.71,0l-10.65-10.65s0,0,0,0,0,0,0,0l-10.04-10.04c-3.03-3.03-7.96-3.03-10.98,0l-21.27,20.08v3.41c0,2.21,1.79,4,4,4Z",
    style: {
      opacity: 0.3,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.61,
    cy: 29.47,
    r: 5.91,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.13 77.52 135.54 83.21 130.93 62.45 149.38 69.1 145.16 73.41 152.67 80.92 147.92 85.67 141.13 77.52",
    style: {
      fill: "#1c2f35",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,63.67l15.97,5.75-3.91,3.99,7.51,7.51-3.59,3.59-6.8-8.16-5.18,5.28-3.99-17.97M129.86,61.23l.62,2.77,3.99,17.97.62,2.81,2.02-2.06,3.97-4.05,5.69,6.83,1.1,1.31,1.21-1.21,3.59-3.59,1.11-1.11-1.11-1.11-6.42-6.42,2.83-2.89,1.71-1.74-2.29-.83-15.97-5.75-2.67-.96h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraightToEditor);
export default __webpack_public_path__ + "static/media/straight-to-editor.59c606a0ddda55f398f0326b25ff1ef9.svg";
export { ForwardRef as ReactComponent };